@let notificationsValue = notifications();
@let unreadNotificationsCountValue = unreadNotificationsCount();
@let isPanelOpenValue = isPanelOpen();
@let hasAccessToNotificationsModifyValue = hasAccessToNotificationsModify();

<div class="notifications">
  <button
    type="button"
    class="notifications__label"
    tooltipPosition="bottom-center"
    showTooltipOnlyOnDesktop
    panelHasPopup="dialog"
    [attr.aria-label]="'header.tooltips.notifications' | translate"
    [kdsTooltip]="'header.tooltips.notifications' | translate"
    [disableTooltip]="isPanelOpenValue"
    [class.notifications__label-active]="isPanelOpenValue"
    [kdsPanelTrigger]="panel"
    [verticalMargin]="0"
    [closeOnContentClick]="false"
    [closeMenu$]="closeMenu$"
    (changePanelVisibility)="onPanelVisibilityChange($event)"
  >
    <i aria-hidden="true" class="notifications__icon fa-regular fa-bell fa--header-texticon"></i>
    @if (unreadNotificationsCountValue > 0) {
      <span class="notifications__count">
        @if (unreadNotificationsCountValue > maximumNotificationCount) {
          {{ maximumNotificationCount }}+
        } @else {
          {{ unreadNotificationsCountValue }}
        }
      </span>
    }
  </button>
</div>

<ng-template #panel>
  <div
    #notificationsPanel
    class="notifications__items"
    role="dialog"
    tabindex="-1"
    [attr.aria-label]="'notifications.title' | translate"
    (keydown.escape)="closePanel()"
    (focusout)="closePanelOnFocusOut($event)"
  >
    <div class="notifications__items-header">
      <span class="notifications__items-header-title">{{ 'notifications.title' | translate }}</span>
      @if (unreadNotificationsCountValue > 0) {
        <button
          #headerAction
          type="button"
          class="notifications__items-header-action"
          [class.notifications__items-header-action--disabled]="!hasAccessToNotificationsModifyValue"
          [attr.aria-disabled]="!hasAccessToNotificationsModifyValue || null"
          [kdsTooltip]="'general.missing-permission' | translate"
          [disableTooltip]="hasAccessToNotificationsModifyValue"
          (click)="markAllNotificationsAsViewed()"
        >
          {{ 'notifications.mark-all-as-read' | translate }}
        </button>
      }

      @if (notificationsValue.length && unreadNotificationsCountValue === 0) {
        <button
          #headerAction
          type="button"
          class="notifications__items-header-action"
          [class.notifications__items-header-action--disabled]="!hasAccessToNotificationsModifyValue"
          [attr.aria-disabled]="!hasAccessToNotificationsModifyValue || null"
          [kdsTooltip]="'general.missing-permission' | translate"
          [disableTooltip]="hasAccessToNotificationsModifyValue"
          (click)="deleteAllNotifications()"
        >
          {{ 'notifications.clear-all' | translate }}
        </button>
      }
    </div>

    @if (loading()) {
      <kds-spinner size="large" variant="absolute" />
    } @else if (!!notificationsValue.length) {
      <div class="notifications__items-content">
        @for (notification of notificationsValue; track notification.id) {
          <itc-notification [notification]="notification" />
        }
      </div>
    } @else {
      <div class="notifications__items-empty">
        <div class="notifications__items-empty-icon"></div>
        <div class="notifications__items-empty-title">{{ 'notifications.empty.title' | translate }}</div>
        <div class="notifications__items-empty-description">{{ 'notifications.empty.description' | translate }}</div>
      </div>
    }
  </div>
</ng-template>
